// @flow
import type { Node } from 'react';
import React from 'react';
import styled, { type StyledComponent } from 'styled-components';

import ScrollToError from '@rover/react-lib/components/utils/ScrollToError';
import { FORM_ERROR_CLASSNAME } from '@rover/react-lib/constants/classNames.constants';
import hasFormError from '@rover/react-lib/utils/hasFormError';

import { defaultProps } from './InnerForm.common';
import { type Props as SharedProps } from './InnerForm.types';

type Props = {
  loading?: Boolean,
  onDelete?: (any) => void,
  ...SharedProps,
};

const StyledForm: StyledComponent<{}> = styled.form`
  width: 100%;
`;

// $FlowFixMe - our flow-typed types for styled-components are out of date and there are none in OSS for this
const NestedForm = StyledForm.withComponent('div');

const InnerForm = ({
  nested,
  children,
  submitted,
  handleSubmit,
  handleKeyPress,
  validationErrors,
  initialValidationErrors,

  // destructure out these props to avoid DOM/prop warnings
  loading,
  onDelete,
  onPreSubmit,
  onLiftedChange,

  ...other
}: Props): Node => {
  const Wrapper = nested ? NestedForm : StyledForm;
  return (
    <Wrapper {...other} onSubmit={handleSubmit} onKeyPress={handleKeyPress}>
      {children}
      <ScrollToError
        shouldScroll={
          // $FlowFixMe
          submitted ? submitted && hasFormError(validationErrors || initialValidationErrors) : false
        }
        errorClass={FORM_ERROR_CLASSNAME}
      />
    </Wrapper>
  );
};

InnerForm.defaultProps = defaultProps;

export default InnerForm;



// WEBPACK FOOTER //
// ../react-lib/src/components/utils/Form/InnerForm/InnerForm.jsx